import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import React, { useState } from "react";
import { createStaticRanges, DateRangePicker } from "react-date-range";
import { Box, Button } from "@mui/material";

const DateRangePickerNew = ({ minDate, maxDate, handleChange, toggleDatepicker }) => {
    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        color: "#5ac36b",
        key: "selection",
    });
    const [show, setShow] = useState(false);

    const handleSelect = (ranges) => {
        setSelectionRange(ranges.selection);
        setShow(true);
    };

    const handleApply = () => {
        handleChange(selectionRange.startDate, selectionRange.endDate);
        toggleDatepicker();
    };

    const subtractMonths = (date, months) => new Date(date.setMonth(date.getMonth() - months));

    const customStaticRanges = createStaticRanges([
        {
            label: "This Week",
            range: () => {
                const today = new Date();
                const firstDayOfWeek = new Date(today);
                firstDayOfWeek.setDate(
                    today.getDate() - (today.getDay() === 0 ? 6 : today.getDay() - 1)
                );
                return {
                    startDate: firstDayOfWeek,
                    endDate: today,
                };
            },
            isSelected() {
                return false;
            },
        },
        {
            label: "This month",
            range: () => ({
                startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                endDate: new Date(),
            }),
            isSelected() {
                return false;
            },
        },
        {
            label: "Last Month",
            range: () => {
                const today = new Date();
                const startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
                return {
                    startDate,
                    endDate: today,
                };
            },
            isSelected() {
                return false;
            },
        },
        {
            label: "Last 3 months",
            range: () => ({
                startDate: subtractMonths(new Date(), 3),
                endDate: new Date(),
            }),
            isSelected() {
                return false;
            },
        },
        {
            label: "Last 6 months",
            range: () => ({
                startDate: subtractMonths(new Date(), 6),
                endDate: new Date(),
            }),
            isSelected() {
                return false;
            },
        },
        {
            label: "Last year",
            range: () => ({
                startDate: subtractMonths(new Date(), 12),
                endDate: new Date(),
            }),
            isSelected() {
                return false;
            },
        },
    ]);

    return (
        <>
            <Box
                sx={{
                    ".rdrMonthName": {
                        color: "white",
                    },
                    ".rdrDayNumber span": {
                        color: "white",
                    },
                    ".rdrMonth": {
                        backgroundColor: "#303030",
                    },
                    ".rdrStaticRange": {
                        borderBottom: "1px solid #101010",
                        padding: 0,
                        background: "#fff",
                        "&:hover, &:focus": {
                            ".rdrStaticRangeLabel": {
                                background: "#505050",
                            },
                        },
                    },
                    ".rdrStaticRangeLabel": {
                        backgroundColor: "#303030",
                    },
                    ".rdrDefinedRangesWrapper": {
                        fontSize: "12px",
                        width: "226px",
                        borderRight: "solid 1px #101010",
                        background: "#303030",
                        ".rdrStaticRangeSelected": {
                            color: "green",
                            fontWeight: 600,
                        },
                    },
                    ".rdrDateRangePickerWrapper": {
                        maxWidth: "100vw",
                    },
                    ".rdrDayDisabled": {
                        backgroundColor: "#303030",
                    },
                    ".rdrDayDisabled .rdrDayNumber span": {
                        color: "#666767",
                    },
                    ".rdrMonthAndYearWrapper": {
                        backgroundColor: "#303030",
                    },
                    ".rdrMonthAndYearPickers": {
                        backgroundColor: "#303030",
                        color: "white",
                    },
                    select: {
                        margin: "40px",
                        backgroundColor: "#373737!important",
                        color: "#fff!important",
                    },
                    "select option": {
                        background: "#303030",
                        color: "white",
                    },
                    "select option:hover": {
                        background: "#505050",
                    },
                    ".rdrDateDisplayWrapper": {
                        backgroundColor: "#303030",
                    },
                    ".rdrInputRange": {
                        display: "none",
                    },
                    ".rdrDateDisplayItem": {
                        borderRadius: "4px",
                        backgroundColor: "#373737",
                        border: "1px solid transparent",
                        input: {
                            cursor: "pointer",
                            height: "2.5em",
                            lineHeight: "2.5em",
                            border: 0,
                            background: "transparent",
                            width: "100%",
                            color: "#849095",
                        },
                    },
                }}
            >
                <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={handleSelect}
                    showSelectionPreview
                    moveRangeOnFirstSelection={false}
                    staticRanges={customStaticRanges}
                    months={2}
                    direction="horizontal"
                    minDate={minDate}
                    maxDate={maxDate}
                    fixedHeight
                />
            </Box>
            {show && <Button onClick={handleApply}> Apply</Button>}
        </>
    );
};

export default DateRangePickerNew;
